import "react-toastify/dist/ReactToastify.css";

// src/App.js
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PermissionProvider } from "./context/PermissionContext";
import { UserProvider } from "./context/UserContext"; // Add this import
import AddClientPage from "./pages/AddClientPage";
import AddUserPage from "./pages/AddUserPage";
import AddSlotPage from "./pages/AddSlotPage";
import AllCitiesPage from "./pages/AllCitiesPage";
import AllClientsPage from "./pages/AllClientsPage";
import AllCountriesPage from "./pages/AllCountriesPage";
import AssignPermissionsPage from "./pages/AssignPermissionPage";
import BranchLocationPage from "./pages/BranchLocationPage";
import ClientBranchesPage from "./pages/ClientBranchesPage";
import ClientPermissionsPage from "./pages/ClientPermissionsPage";
import ClientRolePage from "./pages/ClientRolesPage";
import CustomerProfilePage from "./pages/CustomerProfilePage";
import HomePageNine from "./pages/HomePageNine";
import PlansPage from "./pages/Plans-page";
import RolesPage from "./pages/RolesPage";
import SignInPage from "./pages/SignInPage";
import SlotManagementPage from "./pages/SlotManagementPage";
import StaffPage from "./pages/StaffPage";
import UserPermissionsPage from "./pages/UserPermissionPage";
import UsersListPage from "./pages/UsersListPage";
import VehicleManagementPage from "./pages/VehicleManagementPage";
import AddClientPermissionsPage from "./pages/AddClientPermissionsPage";
import EditUserPage from "./pages/EditUserPage";
import AddPlanPage from "./pages/AddPlanPage";
import UpdatePlanPage from "./pages/UpdatePlanPage";
import UpdateClientPage from "./pages/UpdateClientPage";
import AddUserPermission from "./components/AddUserPermission";
import ProtectedRoute from "./components/ProtectedRoute";
import ClientByIDPage from "./pages/ClientByIDPage";
import InvoicePage from "./pages/InvoicePage";
import BillingSummaryPage from "./pages/BillingSummaryPage";
import { ToastContainer } from "react-toastify";
import WorkflowBuilderPage from "./pages/WorkflowBuilderPage";
import WorkFlowAssignpage from "./pages/WorkFlowAssignPage";
import AssignWorkflowsListPage from "./pages/AssignWorkflowsPage";
import EditWorkFlowPage from "./pages/EditWorkFlowPage";
import ClientsDetailPage from "./pages/ClientsDetailPage";
import TaxesPage from "./pages/TaxRatesPage";
import TaxRatePage from "./pages/TaxRatesPage";
import Profile from "./components/Profile";
import ProfilePage from "./pages/ProfilePage";
import WorkFLowsSuggestionPage from "./pages/WorkFlowsSuggestionPage";
import WorkFLowsSuggestionEditPage from "./pages/WorkflowSuggestionEditPage";
import ViewClientPage from "./pages/ViewClientPage";
import TaxTypespage from "./pages/TaxTypesPage";
import WorkFlowEdit from "./pages/Workflow/WorkFlowEdit";
import VehicleTypesPage from "./pages/VehicleTypesPage";
import VehicleMakesPage from "./pages/VehicleMakesPage";
import VehicleModesPage from "./pages/VehicleModelsPage";
import DashBoard from "./pages/DashBoard";
import AddCountryPage from "./pages/AddCountryPage";
import EditCountryPage from "./pages/EditCountryPage";
import AddTaxRatePage from "./pages/AddTaxRatePage";
import EditTaxRatePage from "./pages/EditTaxRatePage";
import AddClientPermissionPage from "./pages/AddClientPermissionPage";
import EditClientPermissionPage from "./pages/EditClientPermissionPage";
import AddRolePage from "./pages/AddRolePage";
import EditRolePage from "./pages/EditRolePage";
import PlateAuthoritiesPage from "./pages/PlateAuthoritiesPage";
import AddPlateAuthoritiesPage from "./pages/AddPlateAuthoritiesPage";
import EditPlateAuthoritiesPage from "./pages/EditPlateAuthoritiesPage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

 useEffect(() => {
    // Apply 70% zoom to all pages including sign-in
    const applyZoom = () => {
      document.documentElement.style.zoom = "70%";
      if (getComputedStyle(document.documentElement).zoom === "1") {
        document.documentElement.style.transform = "scale(0.7)";
        document.documentElement.style.transformOrigin = "top left";
        document.documentElement.style.width = "142.857%";
        document.documentElement.style.height = "142.857vh";
      }
    };
    applyZoom();
  }, [location.pathname]);

  return (
    <UserProvider>
      {" "}
      {/* Wrap with UserProvider */}
      <PermissionProvider>
        {/* <ErrorHandler> */}
        <Routes>
          <Route path="/sign-in" element={<SignInPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashBoard />} />
            <Route path="/profile" element={<ProfilePage />} />
            {/* Billing */}
            <Route path="/tax-types" element={<TaxTypespage />} />
            <Route path="/tax-rates" element={<TaxRatePage />} />
            <Route path="/add-tax-rates" element={<AddTaxRatePage />} />
            <Route path="/edit-tax-rates/:taxId" element={<EditTaxRatePage />} />

            <Route
              path="/view_billing_summary"
              element={<BillingSummaryPage />}
            />
            {/* Clients */}
            <Route path="/all-clients" element={<AllClientsPage />} />
            <Route path="/add-client" element={<AddClientPage />} />
            <Route path="/view-client/:id" element={<ViewClientPage />} />
            <Route
              path="/update-client/:clientId"
              element={<UpdateClientPage />}
            />
            <Route path="/client-branches" element={<ClientBranchesPage />} />
            <Route path="/branch-location" element={<BranchLocationPage />} />
            <Route path="/client-roles" element={<ClientRolePage />} />
            <Route path="/staff" element={<StaffPage />} />
            <Route
              path="/customer-profile"
              element={<CustomerProfilePage />}
            />
            <Route
              path="/client-permissions"
              element={<ClientPermissionsPage />}
            />
            <Route
              path="/add-client-permissions"
              element={<AddClientPermissionPage />}
            />
            <Route path="/edit-client-permission/:id" element={<EditClientPermissionPage />} />
            
            <Route
              path="/client-management"
              element={<VehicleManagementPage />}
            />
            {/* Geographical */}
            <Route path="/all-countries" element={<AllCountriesPage />} />
            <Route path="/all-cities" element={<AllCitiesPage />} />
            {/* Vehicle */}
            <Route path="/vehicle-types" element={<VehicleTypesPage />} />
            <Route path="/vehicle-makes" element={<VehicleMakesPage />} />
            <Route path="/vehicle-models" element={<VehicleModesPage />} />
            <Route path="/plate-authorities" element={<PlateAuthoritiesPage />} />
            <Route path="/add-plate-authority" element={<AddPlateAuthoritiesPage />} />
            <Route path="/edit-plate-authority/:authorityId" element={<EditPlateAuthoritiesPage />} />
            

            {/* Workflow */}
            <Route path="/workflow-list" element={<WorkflowBuilderPage />} />
            <Route path="/edit-work-flow" element={<WorkFlowEdit />} />
            <Route path="/workflow-assign" element={<WorkFlowAssignpage />} />
            <Route
              path="/assign-workflow"
              element={<AssignWorkflowsListPage />}
            />
            <Route
              path="/workflows-suggestions"
              element={<WorkFLowsSuggestionPage />}
            />
            <Route
              path="/workflows-steps/:ID"
              element={<WorkFLowsSuggestionEditPage />}
            />
            {/* Plan */}
            <Route path="/all-plans" element={<PlansPage />} />
            <Route path="/add-plan" element={<AddPlanPage />} />
            <Route
              path="/update-plan/:plan_id"
              element={<UpdatePlanPage />}
            />
            {/* Users */}
            <Route
              path="/add-user-permission"
              element={<AddUserPermission />}
            />
            <Route path="/all-roles" element={<RolesPage />} />
            <Route path="/all-users" element={<UsersListPage />} />
            <Route path="/add-user" element={<AddUserPage />} />
            <Route path="/add-role" element={<AddRolePage />} />
            <Route path="/edit-role/:roleId" element={<EditRolePage />} />

            <Route path="/edit-user/:userId" element={<EditUserPage />} />
            <Route
              path="/user-permissions"
              element={<UserPermissionsPage />}
            />
            <Route
              path="/assign-permissions"
              element={<AssignPermissionsPage />}
            />

            {/*  */}
            <Route path="/slots" element={<SlotManagementPage />} />
            <Route path="/add-slot" element={<AddSlotPage />} />
            <Route path="/view_invoice/:clientId" element={<InvoicePage />} />
            {/* ❌ */}
            <Route
              path="/view-client/:clientId"
              element={<ClientByIDPage />}
            />
            <Route
              path="/view-client/:clientId"
              element={<ClientsDetailPage />}
            />
            <Route
              path="/add-client-permissions"
              element={<AddClientPermissionsPage />}
            />
            <Route
              path="/add-country"
              element={<AddCountryPage />}
            />
            <Route path="/edit-country/:countryId" element={<EditCountryPage />} /> 

            <Route path="/edit-work-flow-v1" element={<EditWorkFlowPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
          
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={500}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          closeButton={false}
          toastClassName="rounded-5 shadow-md"
        />
        {/* </ErrorHandler> */}
      </PermissionProvider>
    </UserProvider>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;